import { render, staticRenderFns } from "./report50.vue?vue&type=template&id=52b43803&scoped=true"
import script from "./report50.vue?vue&type=script&lang=js"
export * from "./report50.vue?vue&type=script&lang=js"
import style0 from "./report50.vue?vue&type=style&index=0&id=52b43803&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b43803",
  null
  
)

export default component.exports